import store from "../store/index.js";
// utils.js

const setVideoSize = (video, videoWrap) => {           // 调整video背景尺寸
    const videoDom = document.querySelector(video);

    if(!videoDom) {
        return
    }

    let w = videoDom.videoWidth
    , h = videoDom.videoHeight
    , videoRatio = (w / h).toFixed(2);

    let minW, minH;
    if(!videoWrap) {        // 在页面出现横向滚动条时 父容器为body 尺寸会有偏差
        minW = document.documentElement.clientWidth;
        minH = document.documentElement.clientHeight;
    } else {
        minW = document.querySelector(videoWrap).offsetWidth;
        minH = document.querySelector(videoWrap).offsetHeight;
    }
    
    let widthRatio = minW / w
        , heightRatio = minH / h;

    let newWidth, newHeight;
    if (widthRatio > heightRatio) {
        newWidth = minW;
        newHeight = Math.ceil( newWidth / videoRatio );
    }
    else {
        newHeight = minH;
        newWidth = Math.ceil( newHeight * videoRatio );
    }

    videoDom.style.width = newWidth + 'px';
    videoDom.style.height = newHeight + 2 + 'px';   // 防止两边出现视频背景间距
}

const perLoadImg = (imglist, imgprop, callback) => {

    var images = new Array();
    // 加载图片
    for(let i = 0, len = imglist.length; i < len; i++) {
        var objImg = new Image();
        objImg.src = imglist[i];
        images[i] = objImg;
        
        // 将加载图片挂载到vue实例中，防止gc回收
        store.commit("SET_PRELOADIMGLIST", images)
        objImg.onload = function() {
            callback(Math.ceil((1 / imglist.length) * 100 ) * imgprop);
        }
        objImg.onerror= function() {
            callback(Math.ceil((1 / imglist.length) * 100) * imgprop);
        }
    }
}

const perloadVideo = (videolist, videoprop, callback) => {
    // 加载视频
    for(let i = 0, len = videolist.length; i < len; i++) {
        const req = new XMLHttpRequest();
        req.open('GET', videolist[i], true);
        req.responseType = 'blob';
        req.onload = function () {
            if (this.status === 200) {
                const videoBlob = this.response;
                const blobSrc = URL.createObjectURL(videoBlob); // IE10+

                // 保存视频blosrc地址
                store.commit("SET_BLOBURL", blobSrc)
                console.log(`[${videolist[i]}] blobSrc loaded success...`);
                callback(Math.ceil((1 / videolist.length) * 100 * videoprop));
            }
        };
        req.onerror = function () {
            // Error
            console.log("blobSrc loaded error")
            callback(Math.ceil((1 / videolist.length) * 100 * videoProp));
        };
        req.send();
    }
}

const debounce = (method, context, delay) => {       // 防抖动函数，method 回调函数， context 上下文, delay 延迟时间
    let timer
    return function() {
        clearTimeout(timer)
        timer = setTimeout(() => {
            method.apply(context, arguments)
        }, delay)
    }
}

const openWin = (url,name,iWidth,iHeight) => {      // 打开新窗口
    //获得窗口的垂直位置 
    var iTop = (window.screen.availHeight - 30 - iHeight) / 2; 
    //获得窗口的水平位置 
    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2; 
    window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'); 
}

const snsShare = (channel) => {     // sns分享
    switch (channel) {
        case 'fb':
            openWin('http://www.facebook.com/sharer.php?u=' + encodeURIComponent('https://arknights.kr'), 'sharer', 626, 736)
            break;
        case 'tw': 
            openWin('https://twitter.com/share?url=' + encodeURIComponent('https://arknights.kr'), 'sharer', 626, 250)
            break;
        case 'kakao': 
            Kakao.Story.share({
                url: 'https://arknights.kr',
                text: ''
            });
            break;
        default:
            break;
    }
}

const getOrigin = (vue) => {
    console.log(vue.$route.query)
    return vue.$route.query.utm_source || ''
}

export default {
    setVideoSize,
    perLoadImg,
    perloadVideo,
    debounce,
    openWin,
    snsShare,
    getOrigin
}